/*
 * File: ui-form-cell-type.ts
 * File Created: 2024-09-13 12:52:34
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 05:38:57
 * Modified By: Val Liu
 * -----
 */

import { ObjectHelper } from "@root/core/utilities";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "../core";
import { getMoreTagsFromType } from "../ui-type";

// @uiFormCellType - make this form element showing a table cell type.
// allow value: string (cell) | IUIFormCellType

interface IUIFormCellType {
    /// the table cell type.
    /// ex: iv-cell-string
    cell: string;
}

@UITag.set()
export class uiFormCellType extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement, EUITagTarget.FormSubmit];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.String, EUITagRuleType.Object];
    allowNullRule: boolean = false;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input);
        const ro: any = typeof rule === "string" ? { cell: rule } : rule;
        const { cell } = ro;
        if (cell == null) {
            console.error(`<ui-form-cell-type> should provide "cell" type.`);
            return null;
        }

        let moreTags: IUITagMoreTagsUnit[] = [];
        moreTags.push(
            {
                tag: "uiType",
                rule: "iv-form-cell",
            },
            {
                tag: "uiAttrs",
                rule: { cell },
            },
            { tag: "uiSubmitIgnore", rule: true },
            ...getMoreTagsFromType(cell),
        );
        return {
            specials: {
                moreTags,
            },
        };
    }
}
